import React, { useState, useEffect } from 'react';
import './InstallPrompt.css';

const InstallPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent);
    setIsIOS(isIOSDevice);

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      window.deferredPrompt = e; // حفظ في window للاستخدام من Dashboard
      
      const dismissed = localStorage.getItem('installPromptDismissed');
      if (!dismissed && !isIOSDevice) {
        setShowPrompt(true);
      }
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      
      if (outcome === 'accepted') {
        setShowPrompt(false);
        localStorage.setItem('installPromptDismissed', 'true');
      }
      
      setDeferredPrompt(null);
    }
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('installPromptDismissed', 'true');
  };

  if (!showPrompt) {
    return null;
  }

  return (
    <div className="install-prompt-overlay">
      <div className="install-prompt-modal">
        <button className="close-btn" onClick={handleDismiss}>
          ✕
        </button>

        <div className="install-prompt-content">
          <div className="logo-container">
            <img 
              src="/icons/icon-192x192.png" 
              alt="ORASCOM Lab" 
              className="install-logo"
            />
          </div>

          <h2>ORASCOM Lab</h2>
          <p className="install-description">
            ثبّت التطبيق على جهازك للحصول على تجربة أفضل
          </p>

          <div className="install-buttons">
            <button 
              className="btn-install" 
              onClick={handleInstall}
            >
              ✓ ثبّت الآن
            </button>
            <button 
              className="btn-later" 
              onClick={handleDismiss}
            >
              لاحقاً
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstallPrompt;